import {connect} from 'react-redux';
import {Controls as Component} from './Controls';
import {
  createPipette,
  setPipetteControlVisibility,
  setHeld,
  setHeldObject,
  showMoveMenu,
  hideAllControls,
  setVol,
  incVol,
  decVol,
  setCuvetteSolution,

  pushInteractions,
  setPipetteSolution,
  setTipAttached,
  setTipUsed,
  setAnimatingOut,
  setPlungerPosition,
  setCurrentPlungerPos,

  setModal,
  showModal,
  setMoveMenu,

  //TODO ACTION
  // trashFull,
  incSolution,
  decSolution,
  setSolutionMixed,

  setGelLane,
  makeGelImgConfig,
  toggleShowVolumeModal

} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("pipettes") &&
     state.notebook.protocolSection.scene.apparatus.pipettes.some(
       pipette => pipette.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].type,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].controlsVisible,
      tipAttached: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].tipAttached,
      plungerPosition: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].plungerPosition,
      animatingOut: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].animatingOut,
      currentPlungerPos: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].currentPlungerPos,
      solution: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].solution,
      maxVol: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].maxVol,
      volume: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].volume,
      solutionAlias: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id - 1].solutionAlias,
      tipUsed: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id - 1].tipUsed,
      prevSolution: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id - 1].prevSolution,

      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      moveMenuDisplay: state.notebook.protocolSection.scene.moveMenu.display,

      interactionProps: {
        tipBoxes: state.notebook.protocolSection.scene.apparatus.tipBoxes,
        glassTubes: state.notebook.protocolSection.scene.apparatus.glassTubes,
        cuvettes: state.notebook.protocolSection.scene.apparatus.cuvettes,
        trash: state.notebook.protocolSection.scene.apparatus.trash,
      }
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createPipette: (data) => {
      dispatch(createPipette(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setPipetteControlVisibility: (data) => {
      dispatch(setPipetteControlVisibility(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setVol: (data) => {
      dispatch(setVol(data))
    },
    incVol: (data) => {
      dispatch(incVol(data))
    },
    decVol: (data) => {
      dispatch(decVol(data))
    },

    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setPipetteSolution: (data) => {
      dispatch(setPipetteSolution(data))
    },
    setCuvetteSolution: (data) => {
      dispatch(setCuvetteSolution(data))
    },
    setTipAttached: (data) => {
      dispatch(setTipAttached(data))
    },
    setTipUsed: (data) => {
      dispatch(setTipUsed(data))
    },
    setAnimatingOut: (data) => {
      dispatch(setAnimatingOut(data))
    },
    setPlungerPosition: (data) => {
      dispatch(setPlungerPosition(data))
    },
    setCurrentPlungerPos: (data) => {
      dispatch(setCurrentPlungerPos(data))
    },
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },

    // trashFull: (data) => {
    //   dispatch(trashFull(data))
    // },
    incSolution: (data) => {
      dispatch(incSolution(data))
    },
    decSolution: (data) => {
      dispatch(decSolution(data))
    },

    setGelLane: (data) => {
      dispatch(setGelLane(data))
    },

    makeGelImgConfig: (data) => {
      dispatch(makeGelImgConfig(data))
    },

    setSolutionMixed: (data) => {
      dispatch(setSolutionMixed(data))
    },
    toggleShowVolumeModal: (data) => {
      dispatch(toggleShowVolumeModal(data))
    },

  };
}

export const Controls = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
